import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { postRequest } from "../../../constants/api";
import { Loader } from "../../../components";
import { Box, Button, Autocomplete, TextField } from "@mui/material";
import { Container, Form, Row, Col } from "react-bootstrap";
import "../../../../src/constants/report.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const LaporanPenerimaan = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [dariTanggal, setDariTanggal] = useState(new Date());
  let [sampaiTanggal, setSampaiTanggal] = useState(new Date());
  const [noKelompok, setNoKelompok] = useState("");

  const [kelompoks, setKelompoks] = useState([]);
  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lapPembeliansData, setLapPembelianData] = useState([]);
  const navigate = useNavigate();
  const [previewPdf, setPreviewPdf] = useState(false);

  let kelompokOptions = kelompoks.map((kelompok) => ({
    label: `${kelompok.noKelompok}`,
  }));

  useEffect(() => {
    getKelompoksData();
  }, []);

  const getKelompoksData = async () => {
    setLoading(true);
    const allKelompoks = await postRequest(
      `/kelompoks`,
      {},
      navigate,
      dispatch,
    );
    setKelompoks(allKelompoks.data);
    setLoading(false);
  };

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      const lapPembelians = await postRequest(
        `/laporanPenerimaans`,
        {
          dariTanggal,
          sampaiTanggal,
          noKelompok,
        },
        navigate,
        dispatch,
      );
      setLapPembelianData(lapPembelians.data);
      setPreviewPdf(!previewPdf);
    }
  };

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });
    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        await window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const tableTextBorder = {
    letterSpacing: "0.01px",
    borderTop: "1px solid black",
  };

  const textTableRight = {
    letterSpacing: "0.01px",
    textAlign: "right",
  };

  const textTableCenter = {
    letterSpacing: "0.01px",
    textAlign: "center",
  };

  // UI untuk Loop Tampilkan Data
  const list = [];

  let totalAngPerBulan = 0;
  let totalTotalAngsuran = 0;
  let totalBayar = 0;

  for (let i = 0; i < lapPembeliansData.length; i++) {
    totalAngPerBulan += lapPembeliansData[i].angPerBulan;
    totalTotalAngsuran += lapPembeliansData[i].totalAngsuran;
    totalBayar += lapPembeliansData[i].bayar;
    list.push(
      <tr style={tableText}>
        <td>{i + 1}</td>
        <td>{lapPembeliansData[i].angsurankelompok.kelompok.noKelompok}</td>
        <td>{lapPembeliansData[i].angsurankelompok.no}</td>
        <td>{formatDate(lapPembeliansData[i].tglBayar)}</td>
        <td style={textTableRight}>
          {lapPembeliansData[i].angPerBulan.toLocaleString("en-US")}
        </td>
        <td style={textTableRight}>
          {lapPembeliansData[i].totalAngsuran.toLocaleString("en-US")}
        </td>
        <td style={textTableRight}>
          {lapPembeliansData[i].bayar.toLocaleString("en-US")}
        </td>
      </tr>,
    );
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textCenter = {
    textAlign: screenSize >= 650 && "center",
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Penerimaan </h5>
      <hr />
      <Box sx={spacingTop}>
        {/* UI untuk Filter Laporan */}
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Kelompok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={kelompokOptions}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{
                          "& .MuiInputBase-input": {
                            textTransform: "uppercase",
                          },
                        }}
                        placeholder="SEMUA KELOMPOK"
                        {...params}
                      />
                    )}
                    value={noKelompok}
                    onInputChange={(e, value) => {
                      setNoKelompok(value);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {/* UI untuk menampilkan Hasil Laporan */}
      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} id="content" style={pdfContainer}>
            <p>
              {setting.namaPerusahaan} - {setting.alamatPerusahaan}
            </p>
            <p>({setting.kotaPerusahaan})</p>
            <p>{setting.provinsiPerusahaan}</p>
            <p>NO. TELP. {setting.teleponPerusahaan}</p>
            <p>
              Dicetak Oleh: {user.username} | Tanggal:
              {` ${nowDate.getDate().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${nowDate.getFullYear()} `}{" "}
              | Jam:{" "}
              {` ${nowDate.getHours().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}:${nowDate.getSeconds().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })} `}
            </p>
            <h5 style={{ textAlign: "center", fontWeight: "700" }}>
              Laporan Penerimaan
            </h5>
            <p>
              Dari Tanggal :
              {` ${dariTanggal.getDate().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${dariTanggal.getFullYear()} `}{" "}
            </p>
            <p>
              Sampai Tanggal :
              {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}/${sampaiTanggal.getFullYear()} `}{" "}
            </p>
            <p></p>
            <table style={{ width: "1000px" }} class="styled-table">
              <thead>
                <tr>
                  <th style={tableTitle}>NO.</th>
                  <th style={tableTitle}>NO. KELOMPOK</th>
                  <th style={tableTitle}>NO. ANGSURAN</th>
                  <th style={tableTitle}>TGL. BAYAR</th>
                  <th style={tableTitle}>ANGSURAN/BULAN</th>
                  <th style={tableTitle}>TOTAL ANGSURAN</th>
                  <th style={tableTitle}>BAYAR</th>
                </tr>
              </thead>
              <tbody>{list}</tbody>
              <thead>
                <tr style={tableText}>
                  <th style={tableTitle} colSpan="4">
                    TOTAL
                  </th>
                  <th style={tableTitleRight}>
                    {totalAngPerBulan.toLocaleString("en-US")}
                  </th>
                  <th style={tableTitleRight}>
                    {totalTotalAngsuran.toLocaleString("en-US")}
                  </th>
                  <th style={tableTitleRight}>
                    {totalBayar.toLocaleString("en-US")}
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      )}
    </Container>
  );
};

export default LaporanPenerimaan;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "10px",
  letterSpacing: "0.01px",
};

const tableTitle = {
  border: "1px solid black",
  padding: "10px",
  textAlign: "center",
};

const tableTitleRight = {
  border: "1px solid black",
  padding: "10px",
  textAlign: "right",
};
